import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

const LeftMenu = ({ currentPage }) => (
  <div className="col-md-5 col-lg-4 mb-4">
    <aside className="im-left-menu">
      <nav className="im-content-nav">
        <Link href="/content/selling/auction-process">
          <a className={`im-content-nav__item ${currentPage === 'auction-process' ? 'im-content-nav__item--active' : ''}`}>Açık Artırma Nedir?</a>
        </Link>
        <Link href="/content/selling/bargain-auction">
          <a className={`im-content-nav__item ${currentPage === 'bargain-auction' ? 'im-content-nav__item--active' : ''}`}>Pazarlık Usulü Açık Artırma</a>
        </Link>
        <Link href="/content/selling/timed-auction">
          <a className={`im-content-nav__item ${currentPage === 'timed-auction' ? 'im-content-nav__item--active' : ''}`}>Zaman Ayarlı Açık Artırma</a>
        </Link>
        <Link href="/content/selling/buy-now-process">
          <a className={`im-content-nav__item ${currentPage === 'buy-now-process' ? 'im-content-nav__item--active' : ''}`}>Hemen Al Süreci</a>
        </Link>
        <Link href="/content/selling/simple-sales-process">
          <a className={`im-content-nav__item ${currentPage === 'simple-sales-process' ? 'im-content-nav__item--active' : ''}`}>Kolay Satış Sistemi</a>
        </Link>
        <Link href="/content/selling/detailed-expert-report">
          <a className={`im-content-nav__item ${currentPage === 'detailed-expert-report' ? 'im-content-nav__item--active' : ''}`}>Detaylı Ekspertiz Raporu</a>
        </Link>
        <Link href="/content/selling/payment-process">
          <a className={`im-content-nav__item ${currentPage === 'payment-process' ? 'im-content-nav__item--active' : ''}`}>Ödeme Süreci</a>
        </Link>
        <Link href="/content/selling/shipping-and-delivery-process">
          <a className={`im-content-nav__item ${currentPage === 'shipping-and-delivery-process' ? 'im-content-nav__item--active' : ''}`}>Nakliye ve Teslimat Süreci</a>
        </Link>
      </nav>
    </aside>
  </div>
);

LeftMenu.propTypes = {
  currentPage: PropTypes.string,
};

export default LeftMenu;
